import React from 'react';

const BillingAndSATReports = () => {
    return (
        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6", color: "#4F4F4F" }}>
            <div style={{ maxWidth: "800px", marginBottom: "40px" }}>
                <h2 style={{ fontSize: "24px", fontWeight: "300", color: "#000", marginBottom: "10px" }}>
                    Streamline Your Purchase and Services
                </h2>

                <img 
                    src="https://45323494.fs1.hubspotusercontent-na1.net/hubfs/45323494/Screenshot%202024-12-26%20165401-png-1.png" 
                    alt="SAT Report Generation" 
              className="image_gatnix_support"
                />


                <p style={{ fontSize: "16px", marginBottom: "20px" }}>
                    Follow these steps to manage your billing and purchase services effortlessly:
                </p>
                <ol style={{ fontSize: "16px", paddingLeft: "0px", marginBottom: "30px" }}>
                    <li>Access the <strong>Billing Section</strong>: Click on the Billing option in the menu.</li>
                    <li>Add Services to Cart: Select the desired services and add them to your cart.</li>
                    <li>Review Your Cart: Click on the cart symbol in the header to view the selected products.</li>
                    <img 
                    src="https://45323494.fs1.hubspotusercontent-na1.net/hubfs/45323494/Screenshot%202024-12-26%20165445-png-1.png" 
                    alt="SAT Report Generation" 
              className="image_gatnix_support"
                />

                    <li>Proceed to Checkout: Confirm your selection and proceed to the payment stage.</li>
                    <img 
                    src="https://45323494.fs1.hubspotusercontent-na1.net/hubfs/45323494/Screenshot%202024-12-26%20165517-png-1.png" 
                    alt="SAT Report Generation" 
              className="image_gatnix_support"
                />
                    <li>Complete the Payment: Enter your payment details and click <strong>Add Payment Method</strong> to finalize the transaction.</li>
                 

                </ol>
            </div>

    
        </div>
    );
};

export default BillingAndSATReports;
